import { QueryFunction, useQueryClient } from '@tanstack/react-query'
import { useAsyncList } from '@vp/swan'

import { querySearchSuggestions } from '~/app/features/Gallery/queries/querySearchSuggestions'
import { useSelector } from 'react-redux'
import { SEARCH_SUGGESTIONS } from 'shared/constants'
import { getGalleryNameSelector, getLocaleSelector } from '~/app/store/config'
import { buildItems, Item } from '~/app/features/Gallery/components/Header/ActionHeader/components/Searchbox/hooks/utils'
import { getSearchBackend } from '~/app/store/debug/reducer'

export const useSuggestions = (): ReturnType<typeof useAsyncList<Item>> => {
  const queryClient = useQueryClient()

  const galleryName = useSelector(getGalleryNameSelector)
  const locale = useSelector(getLocaleSelector)
  const searchBackend = useSelector(getSearchBackend)

  return useAsyncList<Item>({
    load: async ({ filterText }) => {
      if (!filterText) {
        return buildItems([])
      }

      const result = await queryClient.fetchQuery({
        queryKey: [
          SEARCH_SUGGESTIONS,
          {
            galleryName,
            keyword: filterText as string,
            locale,
            searchBackend,
          },
        ],
        // TODO(DIYCM-2777): Phase 2 - Type search suggestions response properly
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        queryFn: querySearchSuggestions as QueryFunction<any | null>,
        staleTime: Infinity,
      })

      if (!result?.suggestions) {
        return buildItems([])
      }

      return buildItems(result.suggestions)
    },
  })
}
